import { useEffect } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { proxyContextSafeUrl } from '@atlassian/jira-portfolio-3-portfolio/src/common/api/index.tsx';
import type { ReportCheckResponse, ReportCheckResponseError } from './types.tsx';

const request = async (reportId: string) =>
	performGetRequest(
		proxyContextSafeUrl(
			`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`,
		),
	);

export const useReportInitialChecks = (reportId: string) => {
	const { loading, error, data, fetch } = useService<ReportCheckResponse, string>(request);
	useEffect(() => {
		if (!data) {
			fetch(reportId);
		}
	}, [data, fetch, reportId]);

	return {
		loading,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		error: error as unknown as ReportCheckResponseError | undefined,
		data,
		fetch,
	};
};
